import { render, staticRenderFns } from "./FileServerText.vue?vue&type=template&id=8d6db2e0&scoped=true&"
import script from "./FileServerText.vue?vue&type=script&lang=js&"
export * from "./FileServerText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6db2e0",
  null
  
)

export default component.exports